export default "__VITE_ASSET__B28m7P2n__"